import { IProfile } from "../../../../types";
import { callExternalApi } from "../../../services/external-api.service";

class AdminUserHttpClient {
    private _apiServerUrl: string;

    constructor(apiServerUrl = process.env.REACT_APP_API_ORIGIN) {
        this._apiServerUrl = `${apiServerUrl}/v2`;
    }

    async getUser(accessToken: string, userId: number) {
        const config = {
            url: `${this._apiServerUrl}/admin/user/${userId}`,
            method: "GET",
            headers: {
                "Authorization": `Bearer ${accessToken}`
            }
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async uploadUserPhoto(accessToken: string, userId: number, photoFile: File) {
        const formData = new FormData();
        formData.append('file', photoFile, photoFile.name);

        const config = {
            url: `${this._apiServerUrl}/admin/user/${userId}/photo`,
            method: "POST",
            headers: {
                "content-type": "multipart/form-data",
                "Authorization": `Bearer ${accessToken}`,
            },
            data: formData
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async updateUserProfile(accessToken: string, userId: number, profileData: Partial<IProfile>) {
        const config = {
            url: `${this._apiServerUrl}/admin/user/${userId}/profile`,
            method: "PATCH",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                "Content-Type": "application/json"
            },
            data: profileData
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async updateUserEmail(accessToken: string, userId: number, emailAddress: string) {
        const config = {
            url: `${this._apiServerUrl}/admin/user/${userId}/email`,
            method: "PATCH",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                "Content-Type": "application/json"
            },
            data: {
                email_address: emailAddress
            }
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async updateUserRole(accessToken: string, userId: number, role: string) {
        const config = {
            url: `${this._apiServerUrl}/admin/user/${userId}/role`,
            method: "PATCH",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                "Content-Type": "application/json"
            },
            data: {
                role: role
            }
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }

    async updateUserUnsubscribedFromEmails(accessToken: string, userId: number, unsubscribedFromEmails: boolean) {
        const config = {
            url: `${this._apiServerUrl}/admin/user/${userId}/unsubscribed-from-emails`,
            method: "PATCH",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                "Content-Type": "application/json"
            },
            data: {
                unsubscribed_from_emails: unsubscribedFromEmails
            }
        };

        const { data, error } = await callExternalApi({ config });
        return {
            data: data?.data || null,
            error
        };
    }
}

export default AdminUserHttpClient;
